import React from 'react';
import uuid from 'uuid';
import Skeleton from '@atlaskit/skeleton';
import { N20A } from '@atlaskit/theme/colors';
import { RovoAgentIcon } from '@atlassian/conversation-assistant-ui-components';
export var getDummySuggestions = function getDummySuggestions(agent) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  return new Array(length).fill(null).map(function (_, index) {
    return {
      value: "agent:".concat(agent.id, ":").concat(uuid(), ":dummy"),
      label: /*#__PURE__*/React.createElement(Skeleton, {
        width: "".concat(index % 2 !== 0 ? 205 : 180, "px"),
        height: "18px",
        borderRadius: 2,
        isShimmering: true
      }),
      icon: /*#__PURE__*/React.createElement(RovoAgentIcon, {
        label: '',
        excludeOverlay: true,
        size: "large",
        width: 32,
        height: 32,
        primaryColor: "var(--ds-skeleton, ".concat(N20A, ")")
      }),
      groupHeading: '',
      onSelect: function onSelect() {},
      onSuggestionFocused: function onSuggestionFocused() {}
    };
  });
};